import React, { memo } from 'react';
export const PromoBanners = memo(function PromoBanners() {
  return <div className="container mx-auto px-4" data-id="element-2485" data-mp="77g0zgb2evkd">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-2486" data-mp="76ed2b8yael8">
        {/* Banner 1 */}
        <div className="rounded-lg overflow-hidden relative bg-gray-300" data-id="element-2487" data-mp="l5mgxhg26avr">
          <div className="w-full h-32 md:h-40" data-id="element-2488" data-mp="g7kwas2zi3i6"></div>
          <div className="absolute inset-0 flex flex-col justify-center p-4 md:p-6 text-gray-800" data-id="element-2489" data-mp="g5rmx50zl56h">
            <span className="text-xs font-bold bg-white text-gray-600 px-2 py-0.5 rounded w-max mb-2" data-id="element-2490" data-mp="3oll7buyfv0st">
              DIMENSIONS
            </span>
            <h2 className="text-lg md:text-2xl font-bold mb-1" data-id="element-2491" data-mp="28cstmzsg986">1/3 WIDTH</h2>
            <p className="text-xs md:text-sm font-medium mb-2" data-id="element-2492" data-mp="3tn0rlkssl3a5">
              ASPECT RATIO 3:1
            </p>
          </div>
        </div>
        {/* Banner 2 */}
        <div className="rounded-lg overflow-hidden relative bg-gray-300" data-id="element-2493" data-mp="35vbvdtcununx">
          <div className="w-full h-32 md:h-40" data-id="element-2494" data-mp="30xa96zk4nf88"></div>
          <div className="absolute inset-0 flex flex-col justify-center p-4 md:p-6 text-gray-800" data-id="element-2495" data-mp="3txd1mgv7e3u1">
            <span className="text-xs font-bold bg-white text-gray-600 px-2 py-0.5 rounded w-max mb-2" data-id="element-2496" data-mp="2r24gvtbdn7z">
              DIMENSIONS
            </span>
            <h2 className="text-lg md:text-2xl font-bold mb-1" data-id="element-2497" data-mp="7j20wea6dxzt">1/3 WIDTH</h2>
            <p className="text-xs md:text-sm font-medium mb-2" data-id="element-2498" data-mp="bjlzlmaed9o2">
              ASPECT RATIO 3:1
            </p>
          </div>
        </div>
        {/* Banner 3 */}
        <div className="rounded-lg overflow-hidden relative bg-gray-300" data-id="element-2499" data-mp="3b0tws3rfn23a">
          <div className="w-full h-32 md:h-40" data-id="element-2500" data-mp="3fxu5kmfo2iy3"></div>
          <div className="absolute inset-0 flex flex-col justify-center p-4 md:p-6 text-gray-800" data-id="element-2501" data-mp="3jynrxbdgnpov">
            <span className="text-xs font-bold bg-white text-gray-600 px-2 py-0.5 rounded w-max mb-2" data-id="element-2502" data-mp="3oyiljmometdm">
              DIMENSIONS
            </span>
            <h2 className="text-lg md:text-2xl font-bold mb-1" data-id="element-2503" data-mp="z8omb8jw1spf">1/3 WIDTH</h2>
            <p className="text-xs md:text-sm font-medium mb-2" data-id="element-2504" data-mp="146q5dthbds0w">
              ASPECT RATIO 3:1
            </p>
          </div>
        </div>
      </div>
    </div>;
});